var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 5.8c0 1.684-1.123 2.795-2.305 3.964L12 9.958C10.75 11.2 9.5 13 9.5 13S8.25 11.2 7 9.958l-.195-.194C5.623 8.595 4.5 7.484 4.5 5.8c0-2.651 2.239-4.8 5-4.8s5 2.149 5 4.8zM9.537 3L12 5.5 9.537 8 7 5.5 9.537 3zM4 12h3.034c.303.366.6.736.898 1.107.513.64 1.026 1.278 1.568 1.893a52.021 52.021 0 001.575-1.9c.295-.369.59-.737.891-1.1H16l3 7H1l3-7z",
    fill: "#9A9CAC"
  })));
}

export default SvgQuestIcon;